export var isMessagePort = function isMessagePort(sender) {
  return typeof sender.start === 'function';
};